import * as React from 'react';
import { createFileRoute, redirect, useParams } from '@tanstack/react-router';

import { useSite } from '&/features/settings/sites/hooks';
import { VehiclesPage } from '&/features/settings/vehicles/pages/vehicles-page';

export const Route = createFileRoute('/_authenticated/settings_/sites/$siteId/vehicles')({
  beforeLoad: ({ context, params }): void => {
    if (
      context.permissions.isReady &&
      !context.permissions.hasAnyPermission(['sites:manage', 'sites:access-read-only'])
    ) {
      throw redirect({ params: { siteId: params.siteId }, to: '/settings/sites/$siteId' });
    }
  },
  component: SiteVehiclesPage,
});

function SiteVehiclesPage(): React.JSX.Element {
  const { siteId } = useParams({ from: '/_authenticated/settings_/sites/$siteId/vehicles' });
  const { data: site } = useSite(siteId);
  return <VehiclesPage scope="site" siteId={siteId} spaceId={site?.spaceId} />;
}
